module.exports = __webpack_public_path__ + "img/logo_popol_vuh.41c1dc82.png";